import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class EdContentSidebarOpenArrowComponent extends Vue {

  get isSidebarClosed() {
    return !this.$store.state.AppStore.sidebarShown;
  }

  toggleSidebar() {
    this.$App.Store.toggleSidebar()
  }

}